import { Component, Fragment, h, Prop } from '@stencil/core';
import { PersonDoc, RfiDoc } from 'common';
import { PeopleService } from '../../global/service/PeopleService';
import { PersonInfoModal } from '../../components/concourse-person-selector/person-info-modal';
import { RfiUtils, RfiWorkflowUtils } from '..';

@Component({
  tag: 'rfi-card',
  styleUrl: 'rfi-card.css',
  //shadow: true,
})
export class RfiCard {
  @Prop() rfi: RfiDoc;
  @Prop() people: PersonDoc[];

  handlePersonClick(event, person: PersonDoc) {
    event.stopPropagation();
    event.preventDefault();
    PersonInfoModal.presentModal(person);
  }

  render() {
    const state = RfiWorkflowUtils.getCurrentState(this.rfi);
    return (
      <Fragment>
        <ion-card id={this.rfi._id} class={RfiUtils.isDraft(this.rfi) ? 'draft-rfi rfi-card' : 'rfi-card'} role="article">
          <ion-card-header>
            <div class="rfi-card-title">
              <ion-card-title>#{this.rfi.num}</ion-card-title>
              <ion-reorder slot="end"></ion-reorder>
            </div>
            <ion-card-subtitle>{this.rfi.subject}</ion-card-subtitle>
            {state?.dueBy.map(id => {
              const person = this.people.find(p => p._id == id);
              if (!person) return <span>{id}</span>;
              return (
                <ion-chip class="chip" onClick={e => this.handlePersonClick(e, person)}>
                  <ion-avatar>
                    <img src={PeopleService.getIcon(person) || '/assets/img/default-user.jpg'} />
                  </ion-avatar>
                  <ion-label>{PeopleService.getFullName(person)}</ion-label>
                </ion-chip>
              );
            })}
          </ion-card-header>
        </ion-card>
      </Fragment>
    );
  }
}
